// String prototype extensions implementation

import { CommonChecks } from "../../utilities/common-checks.utilities";

// Implement the extension
(String.prototype as any).replaceValuesWithObject = function(dataObject: any): string {
    if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(dataObject) || typeof dataObject !== "object") {
        return this;
    }

    return this.replace(/{(.*?)}/g, (_match: string, param: string) => dataObject[param] ?? '');
};
